/**
 * @module
 * @description
 * Change detection enables data binding in Angular.
 */

export {
  ChangeDetectionStrategy,

  ChangeDetectorRef,

  WrappedValue,
  SimpleChange,
  SimpleChanges,
  PipeTransform,
  DefaultIterableDiffer,
  IterableDiffers,
  IterableDiffer,
  IterableDifferFactory,
  KeyValueDiffers,
  KeyValueDiffer,
  KeyValueDifferFactory,
  CollectionChangeRecord,
  KeyValueChangeRecord,
  TrackByFn
} from './change_detection/change_detection';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
